module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }